import { useSprings } from 'react-spring'

import { from } from 'helpers/springs/spring-move-down'

export const useSpringsMoveDown = (length: number) => {
  return useSprings(length, from)
}
